@let countryCode = country$ | finMap: 'code' | async;
@let countryName = country$ | finMap: 'name' | async;
@let currentLanguage = currentLanguage$ | async | uppercase;
@let currency = currencySymbol$ | async;
<div class="relative dn-mobile">
  <fcom-button
    [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
    [text]="countryName + (hideLanguageTitle() ? '' : '-' + currentLanguage) + ' ' + currency"
    [icon]="{ name: SvgLibraryIcon.LANGUAGE, position: IconPosition.LEFT }"
    (clickBtn)="openLanguageSelector()"
    data-testid="open-language-selector-button"
    fcomPopover
    [content]="contentPopover"
    [options]="popoverOptions"
  />
</div>
<div class="relative dn-tablet-up">
  <fcom-button
    [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
    [text]="
      (showCountryNameInMobile ? countryName : countryCode) +
      (hideLanguageTitle() ? '' : '-' + currentLanguage) +
      ' ' +
      currency
    "
    [icon]="{ name: SvgLibraryIcon.LANGUAGE, position: IconPosition.LEFT }"
    (clickBtn)="openLanguageSelector()"
    data-testid="open-language-selector-button"
    fcomPopover
    [content]="contentPopover"
    [options]="popoverOptions"
  />
</div>

<ng-template #contentPopover>
  <div class="language-selector" data-testid="language-selector">
    <fin-country-and-language-selector
      [hideLanguageOptions]="hideLanguageOptions"
      [lockLanguageSelection]="lockLanguageSelection"
      [hideTitle]="hideTitle"
      (applySelection)="selectLanguageAndRedirect($event)"
      (closeClick)="closeLanguageSelector()"
    />
  </div>
</ng-template>
